// extracted by mini-css-extract-plugin
export var deleteIcon = "_ss-5";
export var deleteOption = "_ss-3";
export var divider = "_ss-2";
export var downloadIcon = "_ss-4";
export var drawer = "_ss-0";
export var drawerFooter = "_ss-6";
export var drawerOpen = "_ss-1";
export var highlighted = "_ss-7";
export var lighterHighlight = "_ss-8";